import { State, Action } from './types';

const reducer = (state: State, action: Action): State => {
  const { type, payload } = action;
  switch (type) {
    case 'REGISTER': {
      return {
        ...state,
        registered: [...state.registered, payload],
      };
    }
    case 'UNREGISTER': {
      const prevState = Array.from(state.registered);
      const idx = prevState.findIndex(anchor => anchor === payload);
      prevState.splice(idx, 1);
      return { ...state, registered: prevState };
    }
    case 'ACTIVATE': {
      return { ...state, active: payload };
    }
    default: {
      throw new Error(`Unhandled action type: ${type}`);
    }
  }
};

export default reducer;
